'use strict';

import config from 'config';
import React, { Component } from 'react';
import CardContainer from 'components/CardContainer';
import ChatRating from 'components/ChatRating';
import zChat from 'vendor/web-sdk';
import ActionButton from 'components/ActionButton';

const { LABELS } = config;

class ChatOverlayRequestRating extends Component {
	constructor(props) {
		super(props);

		this.state = {
			feedback: ''
		};

		this.setFeedback = this.setFeedback.bind(this);
		this.sendFeedback = this.sendFeedback.bind(this);
	}

	setFeedback(event) {
		this.setState( {
			feedback: event.target.value
		} );
	}

	sendFeedback() {
		if ( !! this.state.feedback ) {
			zChat.sendChatComment( this.state.feedback );
		}

		this.props.onClose();
		zChat.endChat();
	}

	focusIn(event) {
		const p = event.target.parentNode.parentNode;

		p.classList.add( 'yith-field-filled' )
	}

	focusOut(event) {
		const p = event.target.parentNode.parentNode,
			input = p.querySelector( 'textarea' );

		if ( ! input.value ) {
			p.classList.remove('yith-field-filled');
		}
	}

	render() {
		return (
			<div className="request-rating">
				<CardContainer title={LABELS.rate_overlay_title || 'Please, rate this chat:'} addClass="" contentAddClass="">
					<ChatRating hasRating={!!this.props.hasRating} rate={this.props.hasRating}/>
				</CardContainer>
				<CardContainer title={LABELS.rate_overlay_subtitle || 'Your feedback:'} addClass="requestFeedback" contentAddClass="">
					<p className="form-row form-row-wide">
						<label>{LABELS.rate_overlay_feedback_field_label || 'Enter your feedback (optional)'}</label>
						<span className="woocommerce-input-wrapper">
							<textarea onChange={this.setFeedback} placeholder="" onFocus={this.focusIn} onBlur={this.focusOut} />
						</span>
					</p>
					<p className="submit-button">
						<ActionButton addClass="send-feedback btn btn-flat-green" label={LABELS.rate_overlay_submit_button || 'Send and close chat'} onClick={this.sendFeedback}/>
					</p>
				</CardContainer>
			</div>
		);
	}
}

ChatOverlayRequestRating.displayName = 'ChatOverlayRequestRating';
ChatOverlayRequestRating.propTypes = {
	hasRating: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.bool
	])
};
export default ChatOverlayRequestRating;


// WEBPACK FOOTER //
// ./src/components/ChatOverlayRequestRating.js